import { API_ROOT_URL } from "../config";

export const counsellorService = {
  counsellorStatus,
  counsellorDetails,
  counsellorProfile,
  counsellorpublicProfile,
  fetchServiceType,
  fetchMultiCounselor
};

function counsellorStatus() {
  const token = JSON.parse(localStorage.getItem("token"));
  const requestOptions = {
    method: "GET",
    headers: { Authorization: "Bearer " + token }
  };
  return fetch(`${API_ROOT_URL}/counsellors/get_status/`, requestOptions).then(handleResponse => {
    return handleResponse.json();
  });
}

function counsellorDetails(counsellorId) {
  const token = JSON.parse(localStorage.getItem("token"));
  const requestOptions = {
    method: "GET",
    headers: { Authorization: "Bearer " + token }
  };
  return fetch(`${API_ROOT_URL}/appointments/get_counsellor_details/?q=${counsellorId}`, requestOptions).then(handleResponse => {
    return handleResponse.json();
  });
}

function counsellorProfile(counsellorId) {
  const requestOptions = {
    method: "GET",
 };
  return fetch(`${API_ROOT_URL}/counsellors/counsellor-profile/?q=${counsellorId}`, requestOptions).then(handleResponse => {
    return handleResponse.json();
  }).catch(err =>{ 
      return err});
}

function counsellorpublicProfile(counsellorName) {
  const requestOptions = {
    method: "GET",
 };
  return fetch(`${API_ROOT_URL}/counsellors/counsellor/profile/?q=${counsellorName}`, requestOptions).then(handleResponse => {
    return handleResponse.json();
  }).catch(err =>{ 
      return err});
}

function fetchServiceType() {
	const token = JSON.parse(localStorage.getItem('token'));
	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + token,
		},
	};
	return fetch(`${API_ROOT_URL}/administrator/service-type/`, requestOptions).then((response) => response.json());
}

function fetchMultiCounselor(){
  const token = JSON.parse(localStorage.getItem('token'));
	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + token,
		},
	};
	return fetch(`${API_ROOT_URL}/counsellors/my_counsellor_multiple/`, requestOptions).then((response) => response.json());
}


// WEBPACK FOOTER //
// ./src/services/counsellor.service.js